import React from 'react';
import classNames from 'classnames';
import s from './custom-video-player.module.scss';
import { PlayerIconButton } from './icon-button';
import { PLAYBACK_RATES } from '../lib/constants';

/** Кнопка скорости воспроизведения + выпадающее меню скоростей */
export const PlaybackRateMenu = ({ playbackRate, show, onToggle, onSelect }) => (
	<div className={s.menuWrapper}>
		<PlayerIconButton onClick={onToggle} ariaLabel="Скорость воспроизведения">
			<span className={s.speedBadge}>{playbackRate === 1 ? '1x' : `${playbackRate}x`}</span>
		</PlayerIconButton>
		{show && (
			<div className={classNames(s.menu, s.speedMenu)}>
				{PLAYBACK_RATES.map((rate) => (
					<button
						key={rate}
						className={classNames(s.menuItem, playbackRate === rate && s.menuItemActive)}
						onClick={() => onSelect(rate)}
					>
						{rate === 1 ? 'Нормальная' : `${rate}x`}
					</button>
				))}
			</div>
		)}
	</div>
);
